import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CourseCatalogLandingPageApiService } from 'app/library/course-catalog-landing-page/services/course-catalog-landing-page.api-service';
import { CourseCatalogLandingPageService } from 'app/library/course-catalog-landing-page/services/course-catalog-landing-page.service';
import { CourseCatalogLandingPageOverview } from 'app/library/course-catalog-landing-page/models/course-catalog-landing-page-overview.model';
import { HelperService } from 'app/projects/shared/src/lib/services/helper';

@Injectable()
export class CourseCatalogOverviewResolver implements Resolve<CourseCatalogLandingPageOverview> {
    constructor(
        private _courseCatalogLandingPageApiService: CourseCatalogLandingPageApiService,
        private _courseCatalogLandingPageService: CourseCatalogLandingPageService,
        private _router: Router,
        private _helperService: HelperService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<CourseCatalogLandingPageOverview> {
        const categoryId = route.paramMap.get('id');

        return this._courseCatalogLandingPageApiService.getCourseCatalogLandingPageOverview(categoryId!).pipe(
            tap((overview) => {
                this._courseCatalogLandingPageService.setOverview(overview);
            }),
            catchError((error: unknown) => {
                if (error instanceof HttpErrorResponse && this.isMissingCatalogLandingPage(error)) {
                    this._helperService.showSnackBarMessage('COURSE_CATALOG.MESSAGE.CATEGORY_LANDING_PAGE_NOT_FOUND');
                    void this._router.navigate(['/catalog'], { replaceUrl: true });
                    return EMPTY;
                }

                return throwError(() => error);
            })
        );
    }

    private isMissingCatalogLandingPage(error: HttpErrorResponse): boolean {
        const body = error.error as { message?: string } | null;
        return error.status === 400 && body?.message === 'landing_page_not_found';
    }
}
